// src/components/common/SelectOptionMessage.tsx
import React from 'react'
import { Option, SpinnerContainer } from '@alefeducation/ui-elements-library-core'
import { SELECT_OPTION_MESSAGES } from '../../utils/constants'

interface Props {
  type: 'loading' | 'error' | 'empty'
}

const messages = {
  loading: <SpinnerContainer />,
  error: SELECT_OPTION_MESSAGES.error,
  empty: SELECT_OPTION_MESSAGES.empty
}

export const SelectOptionMessage: React.FC<Props> = ({ type }) => (
  <Option disabled label="" key={type}>
    <div className="empty-user-message" style={{ textAlign: 'center' }}>
      {messages[type]}
    </div>
  </Option>
)
